import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/shared/failure.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center mb-4"
}
const _hoisted_3 = { class: "flex flex-col w-3/5 gap-0 mx-auto justify-center mt-8 max-md:mt-4 max-md:w-full border border-gray-300 rounded-xl bg-white overflow-hidden" }
const _hoisted_4 = { class: "flex flex-col items-start" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "text-2xl font-bold mt-1" }
const _hoisted_7 = { class: "text-gray-600 text-base font-normal" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "px-8 pb-8 bg-white rounded-b-xl"
}
const _hoisted_10 = { class: "pt-2" }
const _hoisted_11 = { class: "space-y-3 mb-6 w-full items-start text-left px-2" }
const _hoisted_12 = { class: "text-gray-600" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = { class: "flex flex-row items-center gap-2 mb-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "text-sm font-normal leading-5" }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "flex flex-row items-center gap-2 mb-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "text-sm font-normal leading-5" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "flex flex-row items-center gap-2 mb-2" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "text-sm font-normal leading-5" }
const _hoisted_25 = { class: "font-semibold" }
const _hoisted_26 = {
  key: 0,
  class: "flex flex-row items-center gap-2"
}
const _hoisted_27 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
          _createElementVNode("div", {
            role: "alert",
            class: "flex gap-2 w-1/2 justify-center p-2.5 mt-6 text-sm leading-5 text-center text-red-900 bg-red-50 rounded-lg max-md:flex-wrap",
            style: {"max-height":"80px","overflow-y":"auto"}
          }, [
            _createElementVNode("div", { class: "flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Error Icon",
                class: "w-4 h-4"
              })
            ]),
            _createElementVNode("p", null, "Something went wrong. Please try again later.")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "flex flex-row items-center justify-between px-8 py-6 cursor-pointer transition-all duration-200 bg-white rounded-t-xl",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSubscriptionExpanded = !_ctx.isSubscriptionExpanded))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.subscriptionPlanName), 1),
          _createElementVNode("span", _hoisted_6, [
            _createTextVNode(" $" + _toDisplayString(_ctx.billingAmount()) + " ", 1),
            _createElementVNode("span", _hoisted_7, "/" + _toDisplayString(_ctx.subscriptionPlanBillingCycle), 1)
          ])
        ]),
        _createElementVNode("div", {
          innerHTML: _ctx.CHEVRON_RIGHT_ICON,
          class: _normalizeClass([
            'w-8 h-8 text-primary-purple transition-transform duration-200',
            _ctx.isSubscriptionExpanded ? 'rotate-90' : 'rotate-0',
          ])
        }, null, 10, _hoisted_8)
      ]),
      (_ctx.isSubscriptionExpanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "border-t border-gray-200 my-4" }, null, -1)),
            _createElementVNode("div", _hoisted_10, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex flex-col mb-4" }, [
                _createElementVNode("h3", { class: "text-lg font-semibold" }, "What's included:")
              ], -1)),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionPlanFeatures, (feature) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: feature,
                    class: "flex items-start text-left"
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-green-500 mr-2" }, "✓", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(feature), 1)
                  ]))
                }), 128))
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "border-t border-gray-200 my-6" }, null, -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex flex-col mb-4" }, [
                _createElementVNode("h3", { class: "text-lg font-semibold" }, "Subscription Details")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  innerHTML: _ctx.CALENDAR_ICON,
                  class: "w-6 h-6 text-primary-purple flex items-center justify-center"
                }, null, 8, _hoisted_15),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("span", null, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Starts ")),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.subscriptionStartDate), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  innerHTML: _ctx.CLOCK_ICON,
                  class: "w-6 h-6 text-primary-purple flex items-center justify-center"
                }, null, 8, _hoisted_19),
                _createElementVNode("span", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, "$" + _toDisplayString(_ctx.billingAmount()), 1),
                  _cache[6] || (_cache[6] = _createTextVNode(" Due Now (Net30) "))
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  innerHTML: _ctx.BILL_ICON,
                  class: "w-6 h-6 text-primary-purple flex items-center justify-center"
                }, null, 8, _hoisted_23),
                _createElementVNode("span", _hoisted_24, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Billed ")),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.subscriptionPlanBillingCycle.charAt(0).toUpperCase() +
                  _ctx.subscriptionPlanBillingCycle.slice(1)), 1)
                ])
              ]),
              (_ctx.subscriptionAutoRenewal == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.RENEWAL_ICON,
                      class: "w-6 h-6 text-primary-purple flex items-center justify-center"
                    }, null, 8, _hoisted_27),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-sm font-normal leading-5" }, [
                      _createTextVNode(" Renewal "),
                      _createElementVNode("span", { class: "font-semibold" }, " Auto ")
                    ], -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}